import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  small?: boolean;
};

export const HotelBoxTile = styled.div<Props>(
  ({theme, small = false}) => css`
    /* @see https://stackoverflow.com/questions/8468066/child-inside-parent-with-min-height-100-not-inheriting-height */
    display: grid;
    gap: 16px;
    width: 100%;
    min-height: 209px;
    flex-shrink: 0;
    /*  Reset native link styles for the case when this component is rendered as an anchor tag */
    text-decoration: none;
    color: unset;
    -webkit-tap-highlight-color: transparent;

    background: ${theme.colors.backgroundPrimary};
    border-radius: 5px;
    overflow: hidden;
    ${theme.elevations.large};

    ${!small &&
    theme.respondTo(
      'md',
      css`
        grid-template-columns: minmax(0, 6fr) minmax(0, 7fr);
      `
    )}

    ${!small &&
    theme.respondTo(
      'lg',
      css`
        grid-template-columns: minmax(0, 400px) minmax(0, 1fr);
      `
    )}
  `
);
